import { url_join } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898722619';

export function get_compare_url() {
    return url_join(getStack('store')?.key, 'produktvergleich');
}
